<template>
  <div class="text-base relative">
    <select
      :ref="refName"
      :class="inputClasses"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      @change="$emit('input', $event.target.value)"
    >
      <option value="">[ {{ placeholderOption ?? "Selecione" }} ]</option>
      <option v-for="(option, key) in options" :key="key" :value="option.id">
        {{ option.name }}
      </option>
    </select>
    <div class="absolute inset-y-0 right-0 flex px-2 text-gray-700">
      <svg
        class="fill-current h-10 w-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 10"
      >
        <path
          d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
        />
      </svg>
    </div>
    <div v-if="validator && validator.$error">
      <ul
        v-for="(value, key) in validationsMessage"
        :key="key"
        class="input-error"
      >
        <li v-if="!validator[key]">
          {{ value }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    error: Boolean,
    placeholder: String,
    placeholderOption: String,
    required: { default: false },
    disabled: {
      type: Boolean,
      default: false,
    },
    refName: {
      type: String,
    },
    options: {
      type: Array,
      default: null,
    },
    validationsMessage: {
      type: Object,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
  },
  computed: {
    inputClasses() {
      return [
        "w-full appearance-none input-size-default bg-white border text-gray-700 px-4 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-700",
        this.error ? "fail-error" : "border",
      ];
    },
  },
};
</script>
